<template>
  <div class="col-md-12 grid-margin stretch-card">
    <div class="card">
      <div class="card-body" v-if="isLogged">
        <div class="row mb-4">
          <div class="col-md-6">
            <h3 class="font-weight-bold">Gestión de Facturación Electrónica</h3>
          </div>
        </div>


        <div class="white-content-general mb-4">
          <div class="row">
            <div class="col-md-12 col-sm-12">

              <a
                  href="javascript:void(0)"
                  data-toggle="modal"
                  data-target="#modalFiltros"
                  data-backdrop="static"
                  data-keyboard="false"
                  class="btn btn-primary btn-general float-right mb-2 mb-md-0 ml-2"
              >
                <i class="ti-filter menu-icon"></i> Filtrar</a
              >

            </div>
          </div>
        </div>

        <div class="white-content-table">

          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
              <tr>
                <td></td>
                <th>Enviada</th>
                <th>Cliente</th>
                <th>Equipo</th>
                <th>Número Factura</th>
                <th>Solicitud</th>
                <th>Respuesta</th>


              </tr>
              </thead>
              <tbody>

              {{ selectItems }}
              <tr v-for="item in solicitudesFcturas" :key="item">
                <td>
                  <div v-if="!item.enviada">
                    <a href="javascript:void(0)" @click="reenviar(item.id)"
                    ><i class="ti-reload btn-icon-append"></i
                    ></a>
                  </div>

                </td>
                <td>{{ item.enviada === true ? 'SI' : 'NO' }}</td>
                <td>{{ item.codigoCliente }}</td>
                <td>{{ item.codigoBarras }}</td>
                <td>{{ item.numeroFactura }}</td>
                <td>{{ item.solicitud }}</td>
                <td>{{ item.respuesta }}</td>

              </tr>
              </tbody>
            </table>
            <br/>
            <div class="d-flex justify-content-center">
              <nav aria-label="Page navigation example" v-if="paginas">
                <ul class="pagination">
                  <li class="page-item" :disabled="pagina === 1">
                    <a class="page-link" @click="setPreviewPage">
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li
                      v-for="page in paginas"
                      :key="page"
                      class="page-item"
                      :class="{ active: pagina === page }"
                  >
                    <a class="page-link" @click="setPage(page)">{{ page }}</a>
                  </li>
                  <li class="page-item" :disabled="pagina === paginas">
                    <a class="page-link" @click="setNextPage">
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <Filtros
                titulo="Seleccionar filtros"
                :consultar="consultarXFiltros"
                entidad="solicitud_factura_electronica"
            />

            <ModalMessages
                :mensaje="mensajeProceso"
                titulo="Agregar excepción"
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ModalMessages from "../../../components/ModalMessages.vue";
import Filtros from "@/components/CustomFilters.vue";

export default {
  name: "GestionFacturacionElectronica",
  components: {Filtros, ModalMessages},
  data() {
    return {
      pagina: 1,
      mensaje: "",
      id: "",
      valorBusqueda: "",
      tipoFiltro: "",
      mensajeProceso: [],
      selectedItems: [],
      totalRegistros: 0,
      inicializarPagina: false,
      paginaFiltros: 1,
    };
  },
  created() {
    if (!this.$store.getters["auth/isLogged"]) {
      this.$store.dispatch("auth/logout");
      return false;
    }
    this.consultarXFiltros(this.data)

  },
  methods: {
    loaderSpinner() {
      this.loader = this.$loading.show();
    },
    async consultar(pagina) {
      this.loaderSpinner();
      this.valorBusqueda = "";
      try {
        const data = {
          pagina: pagina || 1,
        };
        await this.$store.dispatch(
            "solicitudesFacturas/consultarSolicitudesXPagina",
            data
        );
        await this.$store.dispatch(
            "solicitudesFacturas/consultarTotalPaginas"
        );
        this.pagina = pagina;
      } catch (error) {
        alert("No se pudo realizar la consulta");
      } finally {
        this.loader.hide();
      }
    },

    setPage(page) {
      this.pagina = page;
    },
    setNextPage() {
      if (this.pagina < this.totalPaginas) {
        this.pagina = this.pagina + 1;
      }
    },
    setPreviewPage() {
      if (this.pagina > 1) {
        this.pagina = this.pagina - 1;
      }
    },
    async reenviar(solicitud) {
      this.$swal({
        text: "¿Se realizará el proceso de reenvio?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then(async (result) => {
        this.loaderSpinner();
        if (result.isConfirmed) {
          const resp = await this.$store.dispatch(
              "solicitudesFacturas/reenviar",
              solicitud
          );
          if (resp.success) {
            this.$swal({
              text: "Reenvio realizado con éxito.",
              icon: "success",
            });
            this.loader.hide();
            await this.consultarXFiltros(this.data)
          } else {
            this.$swal({
              text: resp.data,
              icon: "error",
            });
            this.loader.hide();
          }

        }
      });


    },


    async consultarXFiltros(data) {
      this.condiciones = data?.condiciones;

      this.loaderSpinner();
      try {
        await this.$store.dispatch("solicitudesFacturas/consultarSolicitudesFacturasXFiltros", {
          pagina: data?.inicializarPagina ? 1 : this.pagina,
          condiciones: data?.condiciones || [],
        });
        this.totalRegistros = this.$store.getters["solicitudesFacturas/totalRegistros"];
        if (data?.inicializarPagina) {
          this.setPage(1);
          this.inicializarPagina = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loader.hide();
      }
    },

  },
  computed: {
    isLogged() {
      return this.$store.getters["auth/isLogged"]
          ? this.$store.getters["auth/isLogged"]
          : false;
    },
    solicitudesFcturas() {
      return this.$store.getters["solicitudesFacturas/solicitudesFacturas"]
          ? this.$store.getters["solicitudesFacturas/solicitudesFacturas"]
          : [];
    },
    totalPaginas() {
      return this.$store.getters["solicitudesFacturas/totalPaginas"]
          ? this.$store.getters["solicitudesFacturas/totalPaginas"]
          : 0;
    },
    paginas() {
      let numeroPaginas = 10;
      numeroPaginas = Math.min(numeroPaginas, this.totalPaginas);
      let first = this.pagina - Math.floor(numeroPaginas / 2);
      first = Math.max(first, 1);
      first = Math.min(first, this.totalPaginas - numeroPaginas + 1);
      return [...Array(numeroPaginas)].map((k, i) => i + first);
    },
  },
  watch: {
    pagina(newPage, oldPage) {
      if (!newPage) return;

      if (newPage !== oldPage) {
        this.consultarXFiltros({
          condiciones: this.condiciones,
          inicializarPagina: false,
        });
      }
    },
  },
};
</script>
